import { OwcIconButton, OwcTypography } from "@one/react";
import React from "react";
import "./EquipmentTitle.scss";

const EquipmentTitleBar = ({ isEditMode, showTextValue }) => {
  return (
    <div className="equipment-title">
      <div className="equipment-page-title-icon">
        {showTextValue ? (
          <OwcTypography variant="button">My Lab - Bulk Edit</OwcTypography>
        ) : (
          <OwcTypography variant="button">My lab</OwcTypography>
        )}
        <OwcIconButton flat type="outlined" icon="more_vertical" />
      </div>
    </div>
  );
};

export default EquipmentTitleBar;